// extracted by mini-css-extract-plugin
export var sliderDots = "styles-module--sliderDots--0GEvS";
export var button = "styles-module--button--JKeny";
export var arrow = "styles-module--arrow--tI74R";